<script>
  import DropDown from '../DropDown.svelte';
  let assigneeUserId;
  export let extraFilter;
  export let onBulkAction;
  export let selectedTasks = [];
</script>

<!-- Modal -->
<div
  class="modal fade"
  id="changeAssignee"
  tabindex="-1"
  aria-labelledby="changeAssigneeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title font-size-14 border-0"
          id="exampleModalLabel"
        >
          Change Assignee
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="form-group select-block select-client-type">
          <label
            for=""
            class="mb-3 color-lead d-inline-block w-100"
            >{selectedTasks.length} Tasks selected</label
          >
          <DropDown
            deleteSelected={false}
            searchbox={true}
            checkbox={false}
            active={true}
            titleChanged={true}
            title="Assignee"
            labelFields="fullName"
            on:onSelect={(event) => {
              assigneeUserId = event.detail.userId;
            }}
            option={extraFilter.unitUsers}
            Style="select-block d-inline-block font-size-13 select-box-dropdown"
          />
        </div>
      </div>
      <div class="modal-footer border-0">
        <button
          type="button"
          class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
          data-bs-dismiss="modal">Cancel</button
        >
        <button
          type="button"
          class="btn btn-primary m-0 px-4 font-size-12"
          data-bs-dismiss="modal"
          on:click={() => {
            onBulkAction({
              comeFrom: 'changeAssignee',
              assigneeUserId,
            });
          }}>Done</button
        >
      </div>
    </div>
  </div>
</div>
